export default __webpack_public_path__ + "static/media/approved-circle.c6e6a491.svg";